import {AppShortcut, BarButton, SquadflixHeaderType, SquadflixHomePreferences} from "./types";

export const BarButtonsDefault: BarButton[] = [
    {id: "squadflix", order: 1, editable: true},
    {id: "squadflix-search", order: 2, editable: true},
    {id: "home", order: 3, editable: false},
    {id: "drive", order: 4, editable: true},
    {id: "profile-info", order: 5, editable: false}
];

export const defaultHome = "home";

export const squadflixHomeDefaultPreferences: SquadflixHomePreferences = {
    headerType: SquadflixHeaderType.TRENDING_ITEMS,
    showLaLigaEventsSection: false,
    showNewEpisodesSection: true,
    showViewLaterItems: true,
    showTrendingMoviesSection: false,
    showTrendingSeriesSection: false,
    showLiveTvSection: false,
    showSquadflixOriginalsSection: true,
    showTowersStreamSection: true,
};

export const defaultAppShortcuts: AppShortcut[] = [
    {
        name: "Mis Colecciones",
        url: "/my-profile/collections",
        icon: "fa-solid fa-bookmark",
    },
    {
        name: "Mis Reseñas",
        url: "/my-profile/reviews",
        icon: "fa-solid fa-star",
    },
    {
        name: "Configuración",
        url: "/my-profile/config",
        icon: "fa-solid fa-circle-user",
    },
    {
        name: "Mis Grupos",
        url: "/my-profile/groups",
        icon: "fa-solid fa-people-group",
    },
];

export const inbuiltShortcuts: AppShortcut[] = [
    {
        name: "Zona privada",
        url: "/my-profile/private",
        icon: "fa-solid fa-lock",
        disableEdit: true,
    },
    {
        name: "Links Acestream",
        url: "/squadflix/live/custom",
        icon: "fa-solid fa-tower-broadcast",
        disableEdit: true,
    },
];
